import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "admin-layout" };
const _hoisted_2 = { class: "admin-content" };
const _hoisted_3 = { class: "main-content" };
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import HeaderBlock from '@/components/elements/HeaderBlock.vue';
import AdminSideNav from '@/admin/components/AdminSideNav.vue';
import { useAppState } from '@/composables/useAppState';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Admin',
    setup(__props) {
        const route = useRoute();
        const state = useAppState();
        const activeMenuItem = ref('dashboard');
        const isDarkMode = computed(() => state.isDarkMode);
        const pageTitle = computed(() => {
            return route.meta?.title || 'Money Guided Admin Home';
        });
        const headerBgColor = computed(() => {
            return isDarkMode.value ? '#16213e' : '#FBF7F4dd';
        });
        const headerTextColor = computed(() => {
            return isDarkMode.value ? '#e0e0e0' : 'black';
        });
        function handleMenuItemSelect(itemId) {
            activeMenuItem.value = itemId;
        }
        function applyTheme(enabled) {
            const root = document.documentElement;
            if (enabled) {
                root.classList.add('dark-mode');
                root.classList.remove('light-mode');
            }
            else {
                root.classList.add('light-mode');
                root.classList.remove('dark-mode');
            }
        }
        watch(isDarkMode, (val) => applyTheme(val));
        onMounted(() => {
            applyTheme(isDarkMode.value);
        });
        onUnmounted(() => {
            const root = document.documentElement;
            root.classList.remove('dark-mode');
            root.classList.remove('light-mode');
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(HeaderBlock, {
                    title: pageTitle.value,
                    bgcolor: headerBgColor.value,
                    color: headerTextColor.value,
                    border: 0
                }, null, 8, ["title", "bgcolor", "color"]),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(AdminSideNav, {
                        activeItem: activeMenuItem.value,
                        onItemSelected: handleMenuItemSelect
                    }, null, 8, ["activeItem"]),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_router_view)
                    ])
                ])
            ]));
        };
    }
});
